<div class="mss-menu-page" *ngIf="router.url === '/user/messagerie'">
  <div class="mss-menu-card">
      <div class="mss-menu-card-header">
          <div class="title">Messagerie Sécurisé de Santé</div>
      </div>
      <div class="mss-menu-container">
        <div class="card">
            <div class="icon-container">
                <div class="icon">
                    <div class="groupes management"></div>
                </div>
            </div>
            <div class="title">Courriers relevés</div>
            <div class="button-container">
                <a (click)="routeTo($event, 'releves')">
                    <frg-button>
                        <div title="Courriers relevés">Commencer</div>
                    </frg-button>
                </a>
            </div>
        </div>

        <div class="card">
            <div class="icon-container">
                <div class="icon">
                    <div class="groupes management"></div>
                </div>
            </div>
            <div class="title">Boites de réceptions</div>
            <div class="button-container">
                <a (click)="routeTo($event, 'inbox')">
                    <frg-button>
                        <div title="Boites de réceptions">Commencer</div>
                    </frg-button>
                </a>
            </div>
        </div>
    </div>
  </div>
</div>
<div class="inMessagerie" *ngIf="router.url !== '/user/messagerie'">
  <router-outlet></router-outlet>
</div>
